<template>
  <div>
    <RestoreAccountNotification
      :is-vertical="isVertical"
      :active-until="activeUntil"
      :type="type"
      :show-icon="false"
      @restore="showRestoreAccountModal = true"
      @chat="$emit('chat')"
    />
    <EdroneModal
      close-on-esc-key-press
      close-on-outside-click
      :open="showRestoreAccountModal"
      :width="430"
      :show-close-icon="false"
      unique-id="1b9df1fa-fa3d-482d-a076-1d9893dba76e"
      @close="showRestoreAccountModal = false"
    >
      <template #title>{{ trans._cancellation.greatToHaveYouBack }}</template>
      <p class="tw:body-2 tw:mb-4 tw:text-default-700">{{ trans._cancellation.restoreSubDesc }}</p>
      <div class="tw:flex tw:gap-2">
        <EdroneButton :disabled="isLoading" class="tw:w-1/2" type="outline" @click="showRestoreAccountModal = false">
          {{ trans._cancellation.cancel }}
        </EdroneButton>
        <EdroneButton :loading="isLoading" class="tw:w-1/2" @click="$emit('restoreAccount')">
          {{ trans._cancellation.restore }}
        </EdroneButton>
      </div>
    </EdroneModal>
  </div>
</template>

<script lang="ts" setup>
import EdroneModal from "edrone-components/EdroneModal.vue";
import RestoreAccountNotification from "./RestoreAccountNotification.vue";
import EdroneButton from "edrone-components/EdroneButton.vue";
import useRestoreTracker from "vue-app/composables/useRestoreTracker";

interface Props {
  activeUntil?: string | null;
  isVertical?: boolean;
  type?: "small" | "normal";
  isLoading?: boolean;
}
withDefaults(defineProps<Props>(), {
  activeUntil: null,
  isVertical: false,
  type: "normal",
  isLoading: false,
});
defineEmits(["restoreAccount", "chat"]);

const { showRestoreAccountModal } = useRestoreTracker();
</script>
